import { createSlice } from "@reduxjs/toolkit"; 

const initialState = {
  isExpandSidebar: false,
}

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setExpandSidebar: (state, action) => {
      state.isExpandSidebar = action.payload.isExpandSidebar
    }
  }
})

export const { setExpandSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;